import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Config } from '../Config';

@Injectable()
export class ReportLauncher {

  public config = (window as any).config as Config;
  location: Location;

  public reports: IReport[] = [
    {
      name: 'projectStatusReport',
      title: 'Project Status Report',
      component: 'project-status-report',
      inputs: {
        'project-id': 'projectId'
      }
    },
    {
      name: 'projectDetailReport',
      title: 'Project Detail Report',
      component: 'project-detail-report',
      inputs: {
        'project-id': 'projectId'
      }
    }
  ];

  constructor(
    private readonly router: Router,
    location: Location
  ) {
    this.location = location;
  }

  public findReport(reportName) {
    for (const report of this.reports) {
      if (report.name.toLowerCase() === reportName.toLowerCase()) {
        return report;
      }
    }
  }

  /**
   * @param reportName Report name should be full name of report in camel case i.e 'projectListReport'
   * @param reportData report data parameters should reflect required report inputs as shown in models from lines 4-195 in
   *                   report-launcher.ts. Example: {project-ids: [1,2,3]}
   */
  generateReport(reportName: string, reportData?: ReportDataType[]) {
    const report = this.findReport(reportName);
    const localStorageData: { [key: string]: string } = {};
    if (reportData) {
      for (const attributeName of Object.keys(report.inputs)) {
        const attributeValue = report.inputs[attributeName];
        localStorageData[attributeValue] = reportData[attributeValue];
      }
    }
    const reportKeys = Object.keys(window.localStorage).filter(x => x.includes('reportData'));
    const maxLength = 200;
    if (reportKeys.length > maxLength) {
      reportKeys.sort((a, b) => a.localeCompare(b));
      window.localStorage.removeItem(reportKeys[0]);
    }
    const newReportKey = 'reportData-' + Date.now().toString();
    window.localStorage.setItem(newReportKey, JSON.stringify(localStorageData));
    const url = `${this.config.url}${this.config.url.endsWith('/') ? '' : '/'}${report.name}/${newReportKey}`;
    window.open(url, '_blank');
  }
}


export type ReportDataType = 'projectIds' | 'bridgeKeys' | 'county' | 'district' | 'countyMunicipalityCode' | 'congressDistrict' | 'senateDistrict' | 'houseDistrict' | 'planningPartner' | 'reportName' | 'baseUrl';
export interface IReport {
  name: string;
  title: string;
  reportType?: string;
  data?: ReportDataType[];
  tables?: string[];
  disabled?: boolean;
  csvPrint?: boolean;
  selector?: string;
  inputs?: { [key: string]: string };
  component?: string;
}
